import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import NetworkIndex from "../../../mixin/NetworkIndex/index";
// import KpcViewTitle from "../../../components/KpcViewTitle/index.vue";

import Button from "kpc/components/button";
import { Table, TableColumn } from "kpc/components/table";
// import Icon from 'kpc/components/icon';
import Tooltip from "kpc/components/tooltip";
import Input from "kpc/components/input";
import { Select, Option } from "kpc/components/select";
import { Dropdown, DropdownMenu, DropdownItem } from "kpc/components/dropdown";

import TableWithPagination from "../../../components/TableWithPagination/index.vue";

import ColsFilter from "../../../components/ColsFilter/index.vue";
import ColsFilterType, { FilterItem } from "../../../components/ColsFilter/_vue";

import * as _ from "lodash";
import { debounce } from "helpful-decorators";

export const ColumnItemForFilter = (
    title: string,
    key: string,
    width: string | number,
    alwaysCheck: boolean,
    defaultCheck: boolean
): FilterItem => {
    return { title, key, width, alwaysCheck, defaultCheck };
};

@Component({
    components: {
        // KpcViewTitle,
        Button,
        Table,
        TableColumn,
        // Icon,
        Tooltip,
        ColsFilter,
        TableWithPagination,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Select,
        Option,
        Input
    },
    mixins: [NetworkIndex]
})
export default class BaseIndexView extends Vue {
    instanceList: any[] = [];
    instanceListOfChecked: any[] = [];
    tableGroup: any = {};
    searchAttr: string = "";
    searchAttrText: string = "";
    attrlist = [
        {
            value: "Group_name",
            label: Vue.$trans(`安全组名称`)
        },
        {
            value: "Group_id",
            label: Vue.$trans(`安全组ID`)
        },
        {
            value: "inRule_ip",
            label: Vue.$trans(`源IP`)
        },
        {
            value: "outRule_ip",
            label: Vue.$trans(`目标IP`)
        },
        {
            value: "inRule_port",
            label: Vue.$trans(`入站端口`)
        },
        {
            value: "outRule_port",
            label: Vue.$trans(`出站端口`)
        }
    ];

    showAdvSearch = false; //是否显示高级搜索
    searchQuery = "";

    searchPlaceholder = "";

    showExport = true;

    columnMap: any = {};

    // albLoaded = false
    // isShowAlb = false
    // regionsAlb: any[] = []

    listColsFilterName = "defaultListColsFilter";

    @Watch("region")
    regionWatcher() {
        const me: any = this;
        if (!me.region) {
            return;
        }
        me.clickRegion({
            code: me.region
        });
        me.getList(true);
    }

    @Watch("searchAttr")
    searchAttrWatcher(val: any) {
        // const me: any = this;
        // me.searchQuery = "";
        // let str = me.attrlist.filter((item: any) => {
        //     return item.value === val;
        // })[0].label;
        // me.searchAttrText = str;
        // if (val) {
        //     let query =
        //         Vue.$trans(`输入`) +
        //         " " +
        //         me.searchAttrText +
        //         " " +
        //         Vue.$trans(`查询`);
        //     if (val === "Group_name" || val === "Group_id") {
        //         me.searchPlaceholder = query + Vue.$trans(`（支持模糊查询）`);
        //     } else {
        //         me.searchPlaceholder = query + Vue.$trans(`（支持精确查询）`);
        //     }
        // } else {
        //     me.searchPlaceholder = Vue.$trans(
        //         `选择搜索类型，或者输入关键字识别搜索`
        //     );
        // }
    }

    get regionSupport() {
        return true;
    }
    get listSearched() {
        let temp = _.trim(this.searchQuery);
        let splitData = temp.split("：");
        let searchQuery = splitData.length > 1 ? splitData[1] : splitData[0];
        if (!searchQuery) {
            return this.instanceList;
        }
        return _.filter(
            this.instanceList,
            item => JSON.stringify(item).indexOf(searchQuery) !== -1
        );
    }

    created() {
        let me: any = this;
        me.searchPlaceholder = this.$trans(`请选择类型后进行筛选`);
        
        __ksStorage__.on("region", (regionCode: string) => {
            this.region = regionCode;
        });
    }

    reload() {
        this.getList(true);
    }

    selectFun(row: any) {
        let me: any = this;
        me.searchQuery = row.label + "：";
        me.searchAttr = row.value;
        $(me.$refs.searchInput)[0].focus();
    }

    tableMounted() {
        // console.log(this)
        // let ColsFilterRef = this.$refs.ColsFilter as ColsFilterType;
        // ColsFilterRef && ColsFilterRef.init();
    }

    rowKey(data: any) {
        return data;
    }

    // 过滤列太少，可能会导致部分列变形
    // 通过计算判断固定列是否需要指定宽度
    autoScaleTableColumnSize(defaultWidthOrKey: string | number = 100) {
        // let defaultWidth = '100';

        let ColsFilterRef = this.$refs.ColsFilter as ColsFilterType;
        if (ColsFilterRef) {
            let table: any = ColsFilterRef.$parent;
            let widthOfColumns = 0;
            let tableWidth = table.$el.clientWidth;
            let widthOfAuto = 0;
            _.forEach(ColsFilterRef.cols, item => {
                if (
                    typeof defaultWidthOrKey === "string" &&
                    defaultWidthOrKey === item.key &&
                    item.width === "auto"
                ) {
                    defaultWidthOrKey = item.defaultWidth;
                }
                if (ColsFilterRef.checkedKeys.indexOf(item.key) !== -1) {
                    let itemWidth = Number(_.get(item, "width", 0));
                    if (!isNaN(itemWidth)) {
                        widthOfColumns += itemWidth;
                    }
                    if (item.width === "auto") {
                        widthOfAuto += item.defaultWidth;
                    }
                }
            });
            if (tableWidth > widthOfColumns + widthOfAuto) {
                return "";
            }
        }
        // console.log(defaultWidthOrKey, 1111)
        return typeof defaultWidthOrKey === "number" ? defaultWidthOrKey : 100;
    }

    showListColumn(
        key: string,
        title: string,
        width: string | number,
        alwaysCheck: boolean,
        defaultCheck: boolean
        // checkReason: string | undefined
    ) {
        let defaultWidth = 100;
        if (typeof width === "string") {
            let widthSplit = width.split("|");
            if (
                widthSplit.length === 2 &&
                widthSplit[0] === "auto" &&
                /^\d+$/.test(widthSplit[1])
            ) {
                width = "auto";
                defaultWidth = Number(widthSplit[1]);
            }
        }

        this.columnMap[key] = {
            key,
            title,
            width,
            alwaysCheck,
            defaultCheck,
            defaultWidth: defaultWidth ? defaultWidth : 100
            // checkReason
        };
        let ColsFilterRef = this.$refs.ColsFilter as ColsFilterType;
        // console.log(key, ColsFilterRef, 22)
        if (!ColsFilterRef) {
            return true;
        }
        return ColsFilterRef.shouldShow(key);
    }

    @debounce(500)
    async getList(regionChange: boolean = false) {
        this.instanceList = [];
        this.instanceListOfChecked = [];
        this.instanceList = await this.loadList(regionChange);
    }

    //
    async loadList(regionChange: boolean) {
        return [];
    }

    // 待实现
    async exportList() {}

    async mountedHandler() {
        const me: any = this;
        await me.getRegionDetail();
        await this.getList(true);
    }

    async mounted() {
        await this.mountedHandler();
    }
}
